import {Box, CircularProgress, Paper, Stack, Typography} from "@mui/material";
import React from "react";

export const WaitPlease: React.FC = () => {
    return <Box
        sx={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(255, 255, 255, 0.9)', zIndex: 1300,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
    >
        <Paper sx={{p: 4, display: 'flex', alignItems: 'center', gap: 3, boxShadow: 3, borderRadius: 2,}}>
            <CircularProgress size={40} thickness={4} sx={{color: 'primary.main'}}/>
            <Stack spacing={1}>
                <Typography variant="body1" color="text.primary">
                    Even geduld a.u.b...
                </Typography>
            </Stack>
        </Paper>
    </Box>
}